// extracted by mini-css-extract-plugin
module.exports = {"table":"UserActivityReportTable_table__2OIe6","tabs":"UserActivityReportTable_tabs__3Dq_7","paginationWrap":"UserActivityReportTable_paginationWrap__3Mf0f"};